import React from 'react';
import LogosGrid from './LogosGrid';
import { partners } from '../../config/logos';

type ModuleProps = {
  title?: string | null;
};

export default function LogoSection({ title }: ModuleProps) {
  return (
    <LogosGrid items={partners} title={title ?? null} />
  );
}

LogoSection.defaultProps = {
  title: null,
};
